import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ReactTable from "react-table-v6";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Modal,
    Form,
    Input,
    Checkbox,
    Dimmer,
    Loader,
    Message,
    Label
} from "semantic-ui-react";
import ButtonHandler from "../ButtonHandler.jsx";
import processIcon from "../../Images/process.png";
import config from "../../config.js";
import SMSMAutomation from "./StoreMaster SellerMaster/SMSMAutomation.jsx";
import HeroBrandAutomation from "./HeroBrandAutomation.jsx";
import {
    fetchTemplates, fetchUseraction, rawFileProcess,
    psrTargetRawFileProcess, fetchRawFilesData, runLeapAutomation,
    runSubDAutomation, editCredentialsData, updateCredentialsData,
    updateAutoRunStatus,
    getUpdatedTemplateName
} from "../../actions/users_action"


// File configuration mapping - reduces repetition significantly
const FILE_CONFIG = {
    'Channel 1 Target': { status: 'channale1Status', url: 'channel1FileUrl', type: 'simple' },
    'Hotspot Smartspot Execution': { status: 'executionStatus', url: 'executionFileUrl', type: 'simple' },
    'Cluster Master Console File': { status: 'clusterMasterConsoleStatus', url: 'clusterConsoleUrl', type: 'simple' },
    'DGP Target': { status: 'dgpTaregtStatus', url: 'dgpTargetFileUrl', type: 'simple' },
    'ISMP Cluster Incentive Console file': { status: 'ismpConsoleStatus', url: 'ismpConsoleFileUrl', type: 'simple' },
    'SBD Cluster Target': { status: 'sbdClusterTargetStatus', url: 'sbdClusterTargetUrl', type: 'simple' },
    'Visibility Cluster Incentive Console file': { status: 'visibilityConsoleStatus', url: 'visibilityConsolefileUrl', type: 'simple' },
    'WS Target Console File': { status: 'wsTargetConsoleStatus', url: 'wsTargetConsolUrl', type: 'simple' },
    'Red Route Reduction Incentive': { status: 'redRouteTargetStatus', url: 'redRouteTargetUrl', type: 'simple' },
    'WS POTPR Target Console File': { status: 'wsPOTPRTargetConsoleStatus', url: 'wsPOTPRTargetConsolUrl', type: 'simple' },
    'SubDPI Console File': { status: 'subdPiConsoleStatus', url: 'subdPiConsolUrl', type: 'simple' },
    'Chain Master': { status: 'chainMasterStatus', url: 'chainMasterUrl', type: 'simple' },
    'Visibility FB Target': { status: 'visibilityFBTargetStatus', url: 'visibilityFBTargetUrl', type: 'simple' },
    'Visibility Target': { status: 'visibilityTargetStatus', url: 'visibilityTargetUrl', type: 'simple' },
    'MR Cluster Master': { status: 'mrClusterMasterStatus', url: 'mrClusterMasterUrl', type: 'simple' },
    'Adaptive Trade Terms': { status: 'adaptiveTradeTermsStatus', url: 'adaptiveTradeTermsUrl', type: 'simple' },
    'PC DC Template': { status: 'pcdcTemplateStatus', url: 'pcdcTemplateUrl', type: 'simple' },
    'Visibility Champions League targets': { status: 'visibilityChampionTargetStatus', url: 'visibilityChampionTargetUrl', type: 'simple' },
    'BranchSubDStore code changes': { status: 'branchSubdStoreStatus', url: 'branchSubdUrl', type: 'simple' },
    'CENTURY CLUB VCL  TARGET': { status: 'centuryClubStatus', url: 'centuryClubUrl', type: 'simple' },
    'Gold Rush': { status: 'goldRushTemplateStatus', url: 'goldRushTemplateUrl', type: 'simple' },
    'Channel & Photo': { status: 'mergeStatus', url: 'mergeFileUrl', type: 'simple' },
    'Photo Audit': { status: 'photoAuditStatus', url: 'photoAuditFileUrl', type: 'upload' },
    'Physical Audit': { status: 'physicalAuditFileStatus', url: 'physicalAuditFileUrl', type: 'upload' },
    'SGF Fixed rack rate': { status: 'sgfFixedRackRateFileStatus', url: 'sgfFixedRackRateFileUrl', type: 'upload' },
    'DGP Top Channel Corporate Program Targets': { status: 'dgpTopChannelFileStatus', url: 'dgpTopChannelFileUrl', type: 'upload' },
    'Seller vs Physical - SGF final report': { status: 'sgfFinalReportFileStatus', url: 'sgfFinalReportFileUrl', type: 'upload' },
    'Percentage Mapping file': { status: 'percentageMappingFileStatus', url: 'percentageMappingFileUrl', type: 'upload' },
    'PG Target SubDPI': { status: 'pgtargetSubdPiStatus', url: 'pgtargetSubdPiUrl', type: 'upload' },
    'QDGP Target': { status: 'qdgpTargetStatus', url: 'qdgpTargetUrl', type: 'upload' },
    'Visibility Execution Tracker': { status: 'visibilityExecutionTrackerStatus', url: 'visibilityExecutionTrackerUrl', type: 'upload' },
    'Focus Brand Leap': { status: 'fbLeapStatus', url: 'fbLeapFileUrl', type: 'upload' },
    'Focus Brand SubD': { status: 'fbSubdStatus', url: 'fbSubDFileUrl', type: 'upload' },
    'Smartline Leap': { status: 'smartlineLeapStatus', url: 'smartlineLeapFileUrl', type: 'upload' },
    'Smartline SubD': { status: 'smartlineSubDStatus', url: 'smartlineSubDFileUrl', type: 'upload' },
    'SoormaWorking_LEAP': { status: 'soormaLeapStatus', url: 'soormaLeapFileUrl', type: 'upload' },
    'SoormaWorking_SubD': { status: 'soormaSubDStatus', url: 'soormaSubdFileUrl', type: 'upload' },
    'Sector Mapping': { status: 'sectorMappingStatus', url: 'sectorMappingUrl', type: 'upload' },
    'Route Master': { status: 'routeMasterStatus', url: 'routeMasterUrl', type: 'simple' },
    'Hero Brand': { status: 'heroBrandStatus', url: 'heroBrandUrl', type: 'upload' },
};

const COMPOSITE_FILE_CONFIG = {
    'DGPArchivement_LEAP': { status: 'dgpArchivementLeapStatus', url: 'dgpArchivementLeapFileUrl' },
    'DGPArchivement_SubD': { status: 'dgpArchivementSubDStatus', url: 'dgpArchivementSubDFileUrl' },
    'DGPArchivement_Concat': { status: 'dgpArchivementConcatStatus', url: 'dgpArchivementConcatFileUrl' },
    'PSR_LEAP': { status: 'psrLeapStatus', url: 'psrLeapFileUrl' },
    'PSR_SubD': { status: 'psrSubdStatus', url: 'psrSubDFileUrl' },
    'PSR_LeapSubD': { status: 'psrLeapSubdStatus', url: 'psrLeapSubdUrl' },
    'PSR_Concat': { status: 'psrConcatStatus', url: 'psrConcatFileUrl' },
    // changes - all channel psr process
    'PSR_ALL_LEAP': { status: 'psrAllLeapStatus', url: 'psrAllLeapFileUrl' },
    'PSR_ALL_SubD': { status: 'psrAllSubdStatus', url: 'psrAllSubDFileUrl' },
    'PSR_ALL_LeapSubD': { status: 'psrAllLeapSubdStatus', url: 'psrAllLeapSubdUrl' },
    'PSR_ALL_Concat': { status: 'psrAllConcatStatus', url: 'psrAllConcatFileUrl' },  // ✅ FIXED: Changed psrALLConcatFileUrl to psrAllConcatFileUrl
    'PSR_GoldRush': { status: 'psrGoldRushStatus', url: 'psrGoldRushFileUrl' },

    'Soorma_LEAP': { status: 'soormaLeapDseMappingStatus', url: 'soormaLeapDseMappingUrl' },
    'Soorma_SubD': { status: 'soormaSubdDseMappingStatus', url: 'soormaSubdDseMappingUrl' },
    'FB_LEAP': { status: 'fbLeapDseMappingStatus', url: 'fbLeapDseMappingFileUrl' },
    'FB_SubD': { status: 'fbSubdDseMappingStatus', url: 'fbSubdDseMappingUrl' },
    'Smartline_LEAP': { status: 'smartlineLeapDseMappingStatus', url: 'smartlineLeapDseMappingUrl' },
    'Smartline_SubD': { status: 'smartlineSubdDseMappingStatus', url: 'smartlineSubdDseMappingUrl' },
};

const FILE_NAME_ALIAS = {
    'PSR Target': 'PSR',
    'PSR Target All': 'PSR_ALL',  // ✅ ADDED: Alias for PSR All channels
    'PSR - GoldRush': 'PSR',      // ✅ ADDED: Alias for PSR GoldRush
    'DGP Archivement': 'DGPArchivement',
    'Soorma DSE Mapping': 'Soorma',
    'Focus Brand DSE Mapping': 'FB',
    'Smartline DSE Mapping': 'Smartline',
};

const normalizeTemplateName = (name) =>
    (name || '')
        .replace(/\u00A0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

const getDedupedTemplateNames = (names = []) => {
    const unique = new Set();
    names.forEach((name) => {
        const normalized = normalizeTemplateName(name);
        if (normalized) unique.add(normalized);
    });
    return Array.from(unique);
};

const FILE_NAME_CANONICAL_ALIASES = {
    'cluster master': 'Cluster Master Console File',
};

const toCanonicalTemplateName = (name) => {
    const normalized = normalizeTemplateName(name);
    const aliasMatch = FILE_NAME_CANONICAL_ALIASES[normalized.toLowerCase()];
    return aliasMatch || normalized;
};

const findSimpleConfigByFileName = (fileName) => {
    const normalized = toCanonicalTemplateName(fileName).toLowerCase();
    return Object.entries(FILE_CONFIG).find(([name]) => normalizeTemplateName(name).toLowerCase() === normalized)?.[1];
};

const POLL_INTERVAL_MS = 5000;
// How long a just-started run is shown as Processing before the backend has picked it up
const PENDING_RUN_TIMEOUT_MS = 10 * 60 * 1000;
const DYNAMIC_KEY_PREFIX = 'dynamic:';

const STATUS_STYLE = {
    Completed: { color: 'green', icon: 'check circle' },
    Processing: { color: 'orange', icon: 'circle notched', loading: true },
    Failed: { color: 'red', icon: 'warning circle' },
    Pending: { color: 'grey', icon: 'clock outline' },
};

const ALL_FILE_CONFIGS = [...Object.values(FILE_CONFIG), ...Object.values(COMPOSITE_FILE_CONFIG)];

// dd/mm/yyyy hh:mm AM/PM
const formatDateTime = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    const hours = date.getHours();
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} `
        + `${pad(hours % 12 || 12)}:${pad(date.getMinutes())} ${hours < 12 ? 'AM' : 'PM'}`;
};

// Fresh per-file state: every status Pending with no URL, error or date. Applied before
// each server response so nothing carries over from a previously viewed month.
const getEmptyFileState = () => {
    const state = {
        dynamicFileStatusByName: {},
        dynamicFileUrlByName: {},
        dynamicFileUpdatedAtByName: {},
        dynamicFileErrorByName: {},
        missingSectorsList: [],
    };
    ALL_FILE_CONFIGS.forEach(({ status, url }) => {
        state[status] = 'Pending';
        state[url] = '';
        state[`${status}_error`] = null;
        state[`${status}_updatedAt`] = null;
    });
    return state;
};

// Maps an API record to its FILE_CONFIG / COMPOSITE_FILE_CONFIG entry, or to a dynamic template name
const resolveFileConfig = (file) => {
    const normalizedApiFileName = toCanonicalTemplateName(file.fileName);
    const simpleConfig = findSimpleConfigByFileName(normalizedApiFileName);
    if (simpleConfig) return simpleConfig;

    // "Concat All" is matched as "Concat"
    const normalizedFileType = (file.fileType || '').replace(/ All$/, '');
    if (normalizedFileType) {
        const aliasName = FILE_NAME_ALIAS[normalizedApiFileName] || normalizedApiFileName.replace(/\s+/g, '_');
        const compositeConfig = COMPOSITE_FILE_CONFIG[`${aliasName}_${normalizedFileType}`];
        if (compositeConfig) return compositeConfig;
    }
    return { dynamicName: normalizedApiFileName };
};

// Run keys are a config's status key, or `dynamic:<name>` for dynamic template files
const getRunStatus = (state, key) => key.startsWith(DYNAMIC_KEY_PREFIX)
    ? state.dynamicFileStatusByName[key.slice(DYNAMIC_KEY_PREFIX.length)] || 'Pending'
    : state[key] || 'Pending';

const withRunStatus = (state, key, status) => key.startsWith(DYNAMIC_KEY_PREFIX)
    ? { dynamicFileStatusByName: { ...state.dynamicFileStatusByName, [key.slice(DYNAMIC_KEY_PREFIX.length)]: status } }
    : { [key]: status };

const hasProcessingStatus = (state) =>
    ALL_FILE_CONFIGS.some(({ status }) => state[status] === 'Processing')
    || Object.values(state.dynamicFileStatusByName).includes('Processing');

class RawFileProcess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: '',
            templates: [],
            selectedTemplate: '',
            selectedTemplateName: '',
            templateId: '',
            distributors: [],
            modalOpen: false,
            fileUploaded: false,
            fileName: '',
            currentFile: {},
            fileType: '',
            credentialsData: [],
            credentialModalOpen: false,
            distName: '',
            location: '',
            autoRunStatus: '',
            loaderStatus: false,
            Editmode: false,
            editCred: false,
            url: '',
            cloud: '',
            userName: '',
            password: '',
            updatedTemplateNames: [],
            // Store Master / Seller Master modal
            smsmModalOpen: false,
            refreshing: false,
            lastFetchedAt: null,
            ...getEmptyFileState()
        };

        this.pollTimer = null;
        // Runs started from this page that the backend hasn't reported yet: { runKey: { startedAt, prevUpdatedTs } }
        this.pendingRuns = {};
        // Exact last-updated value per run key from the latest response
        this.updatedTsByKey = {};
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                const latestTemplate = res.templates[res.templates.length - 1] || {};
                const latestTemplateId = latestTemplate['_id'] || '';
                this.setState({
                    templates: res.templates,
                    selectedTemplate: latestTemplateId,
                    selectedTemplateName: latestTemplate['name'] || '',
                    templateId: latestTemplateId
                })
                this.props.fetchUseraction(latestTemplateId, {
                    onSuccess: (res) => { this.setState({ distributors: res.users }) },
                    onFailure: () => { this.setState({ loading: false }) }
                });
                this.fetchFileStatuses(latestTemplateId);
                this.props.getUpdatedTemplateName(latestTemplateId, {
                    onSuccess: (res) => {
                        this.setState({ updatedTemplateNames: getDedupedTemplateNames(res.updatedNames) })
                    },
                    onFailure: () => { }
                })
            },
            onFailure: () => { }
        })
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.stopPolling();
    }

    stopPolling = () => {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
    }

    schedulePoll = () => {
        this.stopPolling();
        this.pollTimer = setTimeout(() => this.fetchFileStatuses(), POLL_INTERVAL_MS);
    }

    // Loads statuses for a month; keeps polling while anything is Processing
    fetchFileStatuses = (templateId = this.state.templateId) => {
        if (!templateId) return;
        this.stopPolling();
        this.setState({ refreshing: true });

        this.props.fetchRawFilesData(templateId, {
            onSuccess: (res) => {
                // Ignore responses for a month the user has already switched away from
                if (this.unmounted || templateId !== this.state.templateId) return;
                const hasProcessing = this.applyRawFiles(res.raw_files || []);
                this.setState({ autoRunStatus: res.status, refreshing: false, lastFetchedAt: new Date() });
                if (hasProcessing) this.schedulePoll();
            },
            onFailure: () => {
                if (!this.unmounted) this.setState({ refreshing: false });
            }
        })
    }

    // Replaces all file state with the server's view of the selected month. Returns true if any file is Processing.
    applyRawFiles = (rawFiles) => {
        const next = getEmptyFileState();
        const updatedTsByKey = {};

        rawFiles.forEach((file) => {
            if (!file.fileName) return;
            const status = file.fileStatus || 'Pending';
            const url = (file.result && file.result[0]) || '';
            const config = resolveFileConfig(file);

            if (config.dynamicName) {
                const name = config.dynamicName;
                next.dynamicFileStatusByName[name] = status;
                next.dynamicFileUrlByName[name] = url;
                next.dynamicFileUpdatedAtByName[name] = file.lastUpdated || null;
                next.dynamicFileErrorByName[name] = file.error || null;
                updatedTsByKey[DYNAMIC_KEY_PREFIX + name] = file.lastUpdatedTs || null;
            } else {
                next[config.status] = status;
                next[config.url] = url;
                next[`${config.status}_updatedAt`] = file.lastUpdated || null;
                next[`${config.status}_error`] = file.error || null;
                updatedTsByKey[config.status] = file.lastUpdatedTs || null;
            }

            if (file.fileName === 'PSR Target' && file.fileType === 'LEAP' && file.missingSectorsList) {
                next.missingSectorsList = file.missingSectorsList;
            }
        });

        // A run started here may not be visible on the server yet; keep showing it as
        // Processing until the server reports Processing or a newer update for that file.
        Object.keys(this.pendingRuns).forEach((key) => {
            const run = this.pendingRuns[key];
            const serverPickedUp = getRunStatus(next, key) === 'Processing'
                || (updatedTsByKey[key] || null) !== run.prevUpdatedTs;
            if (serverPickedUp || Date.now() - run.startedAt > PENDING_RUN_TIMEOUT_MS) {
                delete this.pendingRuns[key];
            } else {
                Object.assign(next, withRunStatus(next, key, 'Processing'));
            }
        });

        this.updatedTsByKey = updatedTsByKey;
        this.setState(next);
        return hasProcessingStatus(next);
    }

    markRunStarted = (key) => {
        this.pendingRuns[key] = { startedAt: Date.now(), prevUpdatedTs: this.updatedTsByKey[key] || null };
        this.setState(prev => withRunStatus(prev, key, 'Processing'));
    }

    markRunFailed = (key) => {
        if (key) delete this.pendingRuns[key];
        this.fetchFileStatuses();
    }

    dropDownFileOnChange = (e, data) => {
        // Open SMSM modal directly instead of the standard file upload flow
        if (data.value === 'StoreMaster/SellerMaster') {
            this.setState({ smsmModalOpen: true, selectedFile: data.value })
            return
        }
        this.setState({ selectedFile: data.value, selectedDistributor: '' })
    }

    dropDownTemplateOnChange = (e, data) => {
        const selectedTemplateId = data.value;
        const selectedTemplate = this.state.templates.find(t => t._id === selectedTemplateId) || {};
        this.stopPolling();
        this.pendingRuns = {};
        this.updatedTsByKey = {};
        // Clear the previous month's statuses immediately so they never show against this month
        this.setState({
            templateId: selectedTemplateId,
            selectedTemplate: selectedTemplateId,
            selectedTemplateName: selectedTemplate.name || '',
            lastFetchedAt: null,
            ...getEmptyFileState()
        }, () => {
            this.fetchFileStatuses(selectedTemplateId);
            this.props.getUpdatedTemplateName(selectedTemplateId, {
                onSuccess: (res) => {
                    this.setState({ updatedTemplateNames: getDedupedTemplateNames(res.updatedNames) });
                },
                onFailure: () => { }
            })
        })
    }

    dropDownDistributorOnChange = (e, data) => {
        this.setState({ selectedDistributor: data.value })
    }

    closeuploadoption = () => {
        this.setState({ modalOpen: false })
    }

    uploadRawFile = (file_type, fileName = this.state.fileName) => {
        const distributorFiles = ['PSR Target', 'PSR Target All', 'DGP Archivement', 'Soorma DSE Mapping',
            'Focus Brand DSE Mapping', 'Smartline DSE Mapping'];

        const uploadFiles = ['Photo Audit', 'Visibility Execution Tracker', 'Physical Audit',
            'PG Target SubDPI', 'QDGP Target', 'Credential File',
            'SGF Fixed rack rate', 'DGP Top Channel Corporate Program Targets',
            'Seller vs Physical - SGF final report', 'Percentage Mapping file',
            'Focus Brand Leap', 'Focus Brand SubD', 'Smartline Leap',
            'Smartline SubD', 'SoormaWorking', 'Sector Mapping', 'Hero Brand'];

        if (distributorFiles.includes(fileName)) {
            // Strip " ALL" suffix for backend compatibility
            let backendFileType = file_type;
            if (file_type === "LEAP ALL") {
                backendFileType = "LEAP";
            } else if (file_type === "SubD ALL") {
                backendFileType = "SubD";
            }

            const aliasName = FILE_NAME_ALIAS[fileName] || fileName;
            const normalizedFileType = file_type.replace(/ ALL$/, '');
            const compositeConfig = COMPOSITE_FILE_CONFIG[`${aliasName}_${normalizedFileType}`];
            const runKey = compositeConfig ? compositeConfig.status : null;
            if (runKey) this.markRunStarted(runKey);

            this.props.psrTargetRawFileProcess(
                this.state.currentFile, fileName,
                this.state.selectedDistributor, backendFileType,
                this.state.templateId, {
                onSuccess: () => {
                    alert('File processing start');
                    this.setState({ modalOpen: false });
                    this.schedulePoll();
                },
                onFailure: () => this.markRunFailed(runKey)
            }
            );

        } else if (uploadFiles.includes(fileName)) {
            this.setState({ loaderStatus: true });
            this.props.rawFileProcess(this.state.currentFile, fileName, this.state.templateId, {
                onSuccess: () => {
                    const config = FILE_CONFIG[fileName];
                    const stateUpdate = { modalOpen: false, loaderStatus: false };
                    if (config) stateUpdate[config.status] = 'Completed';
                    this.setState(stateUpdate);
                    alert("File Uploaded Successfully");
                    // Pick up the saved record's last updated date
                    this.fetchFileStatuses();
                },
                onFailure: () => {
                    this.setState({ loaderStatus: false });
                }
            });

        } else {
            // Start button flow - show Processing immediately
            const config = FILE_CONFIG[fileName];
            const normalizedFileName = toCanonicalTemplateName(fileName);
            const isDynamic = this.state.updatedTemplateNames.some(name => toCanonicalTemplateName(name) === normalizedFileName);

            // Composite files (like PSR All Concat)
            const aliasName = FILE_NAME_ALIAS[fileName] || fileName;
            const normalizedFileType = file_type.replace(/ All$/, '');
            const compositeConfig = COMPOSITE_FILE_CONFIG[`${aliasName}_${normalizedFileType}`];

            let runKey = null;
            if (config) runKey = config.status;
            else if (compositeConfig) runKey = compositeConfig.status;
            else if (isDynamic) runKey = DYNAMIC_KEY_PREFIX + normalizedFileName;
            if (runKey) this.markRunStarted(runKey);

            this.props.rawFileProcess(this.state.currentFile, fileName, this.state.templateId, {
                onSuccess: () => {
                    alert('File processing start');
                    this.setState({ modalOpen: false });
                    this.schedulePoll();
                },
                onFailure: () => this.markRunFailed(runKey)
            });
        }
    }

    renderStatusLabel = (status) => {
        const style = STATUS_STYLE[status] || STATUS_STYLE.Pending;
        return (
            <Label color={style.color} basic={status === 'Pending'}>
                <Icon name={style.icon} loading={style.loading} />
                {status}
            </Label>
        );
    }

    renderLastUpdated = (lastUpdated) => (
        <div style={{ marginTop: 10, fontSize: '0.92em', color: lastUpdated ? 'rgba(0,0,0,.7)' : 'rgba(0,0,0,.45)' }}>
            <Icon name='calendar alternate outline' />
            {lastUpdated
                ? <>Last updated: <strong>{lastUpdated}</strong></>
                : 'Not run for this month yet'}
        </div>
    )

    // Helper: Render generic card with configurable action button
    renderCard = (config) => {
        const {
            title,
            description,
            statusKey,
            urlKey,
            statusValue,
            urlValue,
            updatedAtValue,
            errorValue,
            fileName,
            fileType,
            actionType = 'play',
            customActions = null,
            additionalContent = null
        } = config;

        const hasStatus = Boolean(statusKey) || typeof statusValue !== 'undefined';
        const status = statusKey ? (this.state[statusKey] || 'Pending') : (statusValue || 'Pending');
        const url = urlKey ? this.state[urlKey] : (urlValue || '');
        const lastUpdated = statusKey ? this.state[`${statusKey}_updatedAt`] : updatedAtValue;
        const error = statusKey ? this.state[`${statusKey}_error`] : errorValue;
        const isCompleted = status === 'Completed';
        const isProcessing = status === 'Processing';

        const actionMap = {
            play: { icon: 'play', label: 'Start' },
            upload: { icon: 'upload', label: 'Upload' }
        };

        const actionConfig = actionMap[actionType];

        return (
            <Card fluid key={`${fileName}_${fileType}`} style={{ maxWidth: 420, height: '100%' }}>
                <Card.Content>
                    <Image floated='right' size='mini' src={processIcon} />
                    <Card.Header>{title}</Card.Header>
                    <Card.Meta style={{ marginTop: 4 }}>{description}</Card.Meta>
                    {hasStatus && (
                        <Card.Description style={{ marginTop: 14 }}>
                            {this.renderStatusLabel(status)}
                            {this.renderLastUpdated(lastUpdated)}
                            {status === 'Failed' && error && (
                                <Message negative size='tiny' style={{ marginTop: 10 }}>{error}</Message>
                            )}
                        </Card.Description>
                    )}
                </Card.Content>
                <Card.Content extra>
                    <div style={{ display: 'flex', justifyContent: 'space-around', gap: '10px' }}>
                        {customActions ? (
                            customActions
                        ) : (
                            <>
                                <Button
                                    basic color='blue'
                                    onClick={() => this.uploadFile(fileName, fileType)}
                                    disabled={isProcessing}
                                >
                                    <Icon name={actionConfig.icon} />
                                    {hasStatus && isCompleted
                                        ? (actionType === 'upload' ? 'Re-upload' : 'Re-run')
                                        : actionConfig.label}
                                </Button>
                                {hasStatus && (
                                    <Button
                                        basic color='green'
                                        onClick={() => this.downloadFile(url)}
                                        disabled={!isCompleted || !url}
                                    >
                                        <Icon name="download" />
                                        Download
                                    </Button>
                                )}
                            </>
                        )}
                    </div>
                    {additionalContent}
                </Card.Content>
            </Card>
        );
    }

    // Helper: Render process card (Start/Download)
    renderProcessCard = (title, description, statusKey, urlKey, fileName, fileType) => {
        return this.renderCard({ title, description, statusKey, urlKey, fileName, fileType, actionType: 'play' });
    }

    // Helper: Render upload file card
    renderUploadCard = (title, description, statusKey, urlKey, fileName, fileType) => {
        return this.renderCard({ title, description, statusKey, urlKey, fileName, fileType, actionType: 'upload' });
    }

    // Helper: Render simple status card with upload/download or start actions
    renderStatusCard = (title, description, statusKey, urlKey, fileName, fileType, actionType = 'upload') => {
        return this.renderCard({ title, description, statusKey, urlKey, fileName, fileType, actionType });
    }

    // Helper: Render composite cards (LEAP, SubD, Concat, etc.)
    renderCompositeCards = (fileName, items, columns = 3) => {
        const cardConfigs = items.map(item => ({
            title: item.title,
            description: item.description,
            statusKey: item.statusKey,
            urlKey: item.urlKey,
            fileName: fileName,
            fileType: item.fileType
        }));

        return this.renderCardGrid(cardConfigs, columns);
    }

    // Helper: Render multiple cards in a grid
    renderCardGrid = (cards, columns = 3) => {
        return (
            <Grid columns={columns} style={{ marginTop: 20 }}>
                {cards.map((cardConfig, idx) => (
                    <GridColumn key={idx}>
                        {cardConfig.type === 'process'
                            ? this.renderProcessCard(
                                cardConfig.title,
                                cardConfig.description,
                                cardConfig.statusKey,
                                cardConfig.urlKey,
                                cardConfig.fileName,
                                cardConfig.fileType
                            )
                            : this.renderUploadCard(
                                cardConfig.title,
                                cardConfig.description,
                                cardConfig.statusKey,
                                cardConfig.urlKey,
                                cardConfig.fileName,
                                cardConfig.fileType
                            )
                        }
                    </GridColumn>
                ))}
            </Grid>
        );
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    uploadFile = async (fileName, type) => {
        this.setState({ fileName: fileName, fileType: type });

        if (fileName == 'Photo Audit' || fileName == 'Visibility Execution Tracker' ||
            fileName == 'Physical Audit' || fileName == 'PG Target SubDPI' ||
            fileName == 'QDGP Target' || fileName == 'Credential File' ||
            fileName == 'SGF Fixed rack rate' || fileName == 'DGP Top Channel Corporate Program Targets' ||
            fileName == 'Seller vs Physical - SGF final report' ||
            fileName == 'Percentage Mapping file' || fileName == 'Focus Brand Leap' ||
            fileName == 'Focus Brand SubD' || fileName == 'Smartline Leap' ||
            fileName == 'Smartline SubD' || fileName == 'SoormaWorking' ||
            fileName == 'Sector Mapping' || fileName == 'Hero Brand') {
            this.setState({ modalOpen: true });
        } else {
            this.uploadRawFile(type, fileName);
        }
    }

    downloadFile = (url) => {
        window.open(url);
    }

    runLeap = () => {
        this.props.runLeapAutomation({
            onSuccess: () => { },
            onFailure: () => { }
        })
    }

    runSubd = () => {
        this.props.runSubDAutomation({
            onSuccess: () => { },
            onFailure: () => { }
        })
    }

    editCredentials = async () => {
        await this.props.editCredentialsData({
            onSuccess: (res) => {
                this.setState({ credentialsData: res, credentialModalOpen: true })
            },
            onFailure: () => { }
        })
    }

    closeModal = () => {
        this.setState({ Editmode: false })
    }

    editCredentialDetail = (data) => {
        console.log(data, 'data')
        this.setState({
            Editmode: true,
            userName: data['User Name'],
            password: data['Password'],
            cloud: data['Cloud'],
            url: data['URL'],
            distName: data['Distributor Name'],
            location: data['Location'],
            editCred: false
        })
    }

    urlChange = (e) => {
        this.setState({ url: e.target.value, editCred: true })
    }

    cloudChange = (e) => {
        this.setState({ cloud: e.target.value, editCred: true })
    }

    userNameChange = (e) => {
        this.setState({ userName: e.target.value, editCred: true })
    }

    passwordChange = (e) => {
        this.setState({ password: e.target.value, editCred: true })
    }

    saveCredentialData = () => {
        console.log(this.state.cloud, 'cloud')
        let credentialMaster = this.state.credentialsData
        credentialMaster.map((d) => {
            if (d['Distributor Name'] == this.state.distName && d['Location'] == this.state.location) {
                d['Cloud'] = this.state.cloud != '' ? this.state.cloud : d['Cloud']
                d['URL'] = this.state.url != '' ? this.state.url : d['URL']
                d['User Name'] = this.state.userName != '' ? this.state.userName : d['User Name']
                d['Password'] = this.state.password != '' ? this.state.password : d['Password']
            }
        })
        this.setState({ credentialsData: credentialMaster, Editmode: false })
        let data = { credentialMaster: credentialMaster }
        this.props.updateCredentialsData(data, {
            onSuccess: (res) => { },
            onFailure: () => { }
        })
    }

    check = (e, value) => {
        let data = { status: '' }
        data.status = value.checked == true ? 'enable' : 'disable'
        this.setState({ autoRunStatus: data.status })
        this.props.updateAutoRunStatus(data, {
            onSuccess: () => { },
            onFailure: () => { }
        })
    }

    render() {

        var templateMonths = []
        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d._id,
                'text': d.name
            })
        })

        var distributors_list = []
        this.state.distributors.map((d) => {
            if (d.siteName) {
                distributors_list.push({
                    'key': d._id,
                    'value': d.siteName + '-' + d.location,
                    'text': d.siteName + '-' + d.location
                })
            }
        })

        var columns = [
            { Header: "Location", accessor: "Location" },
            { Header: "Distributor Name", accessor: "Distributor Name" },
            { Header: "URL", accessor: "URL" },
            { Header: "Cloud", accessor: "Cloud" },
            { Header: "User Name", accessor: "User Name" },
            { Header: "Password", accessor: "Password" },
            {
                Header: "Edit",
                accessor: "editing",
                Cell: (row) => (
                    <div>
                        {!this.state.Editmode && (
                            <Icon
                                name="edit"
                                onClick={() => this.editCredentialDetail(row.original)}
                                style={{
                                    width: 100,
                                    align: "center",
                                    size: "huge",
                                    marginLeft: "25%",
                                    cursor: "pointer",
                                    color: "green",
                                }}
                            />
                        )}
                    </div>
                ),
            }
        ]

        const defaultFileTypes = [
            { key: 'Channel 1 Target', value: 'Channel 1 Target', text: 'Channel 1 Target' },
            { key: 'Hotspot Smartspot Execution', value: 'Hotspot Smartspot Execution', text: 'Hotspot Smartspot Execution' },
            { key: 'Cluster Master Console File', value: 'Cluster Master Console File', text: 'Cluster Master Console File' },
            { key: 'DGP Target', value: 'DGP Target', text: 'DGP Target' },
            { key: 'ISMP Cluster Incentive Console file', value: 'ISMP Cluster Incentive Console file', text: 'ISMP Cluster Incentive Console file' },
            { key: 'SBD Cluster Target', value: 'SBD Cluster Target', text: 'SBD Cluster Target' },
            { key: 'Visibility Cluster Incentive Console file', value: 'Visibility Cluster Incentive Console file', text: 'Visibility Cluster Incentive Console file' },
            { key: 'WS Target Console File', value: 'WS Target Console File', text: 'WS Target Console File' },
            { key: 'WS POTPR Target Console File', value: 'WS POTPR Target Console File', text: 'WS POTPR Target Console File' },
            { key: 'SubDPI Console File', value: 'SubDPI Console File', text: 'SubDPI Console File' },
            { key: 'Chain Master', value: 'Chain Master', text: 'Chain Master' },
            { key: 'Visibility FB Target', value: 'Visibility FB Target', text: 'Visibility FB Target' },
            { key: 'Visibility Target', value: 'Visibility Target', text: 'Visibility Target' },
            { key: 'MR Cluster Master', value: 'MR Cluster Master', text: 'MR Cluster Master' },
            { key: 'Adaptive Trade Terms', value: 'Adaptive Trade Terms', text: 'Adaptive Trade Terms' },
            { key: 'PC DC Template', value: 'PC DC Template', text: 'PC DC Template' },
            { key: 'Visibility Champions League targets', value: 'Visibility Champions League targets', text: 'Visibility Champions League targets' },
            { key: 'BranchSubDStore code changes', value: 'BranchSubDStore code changes', text: 'BranchSubDStore code changes' },
            { key: 'CENTURY CLUB VCL  TARGET', value: 'CENTURY CLUB VCL  TARGET', text: 'CENTURY CLUB VCL  TARGET' },
            { key: 'QDGP Target', value: 'QDGP Target', text: 'QDGP Target' },
            { key: 'Gold Rush', value: 'Gold Rush', text: 'Gold Rush' },
            { key: 'DGP Archivement', value: 'DGP Archivement', text: 'DGP Archivement' },
            { key: 'Smartspot DGP Archivement', value: 'Smartspot DGP Archivement', text: 'Smartspot DGP Archivement' },
            { key: 'PSR', value: 'PSR', text: 'PSR' },
            { key: 'Photo Audit', value: 'Photo Audit', text: 'Photo Audit' },
            { key: 'Physical Audit', value: 'Physical Audit', text: 'Physical Audit' },
            { key: 'Channel & Photo', value: 'Channel & Photo', text: 'Channel & Photo' },
            { key: 'SGF Fixed rack rate', value: 'SGF Fixed rack rate', text: 'SGF Fixed rack rate' },
            { key: 'DGP Top Channel Corporate Program Targets', value: 'DGP Top Channel Corporate Program Targets', text: 'DGP Top Channel Corporate Program Targets' },
            { key: 'Seller vs Physical - SGF final report', value: 'Seller vs Physical - SGF final report', text: 'Seller vs Physical - SGF final report' },
            { key: 'Percentage Mapping file', value: 'Percentage Mapping file', text: 'Percentage Mapping file' },
            { key: 'DSE Mapping', value: 'DSE Mapping', text: 'DSE Mapping' },
            { key: 'PG Target SubDPI', value: 'PG Target SubDPI', text: 'PG Target SubDPI' },
            { key: 'Visibility Execution Tracker', value: 'Visibility Execution Tracker', text: 'Visibility Execution Tracker' },
            { key: 'Red Route Reduction Incentive', value: 'Red Route Reduction Incentive', text: 'Red Route Reduction Incentive' },
            { key: 'Route Master', value: 'Route Master', text: 'Route Master' },
            { key: 'Hero Brand', value: 'Hero Brand', text: 'Hero Brand' },
            { key: 'StoreMaster/SellerMaster', value: 'StoreMaster/SellerMaster', text: 'StoreMaster / SellerMaster' },
        ];

        const staticTemplateNameSet = new Set(defaultFileTypes.map(item => toCanonicalTemplateName(item.key)));
        const staticTemplateNameMap = new Map(
            defaultFileTypes.map(item => [toCanonicalTemplateName(item.key).toLowerCase(), item.key])
        );
        const apiTemplateNames = getDedupedTemplateNames(this.state.updatedTemplateNames);
        const fileTypes = (() => {
            const merged = [...defaultFileTypes];
            const existingKeys = new Set(defaultFileTypes.map(item => toCanonicalTemplateName(item.key)));

            apiTemplateNames.forEach((name) => {
                const normalizedLower = toCanonicalTemplateName(name).toLowerCase();
                const canonicalName = staticTemplateNameMap.get(normalizedLower) || toCanonicalTemplateName(name);
                if (!canonicalName || existingKeys.has(canonicalName)) return;
                existingKeys.add(canonicalName);
                merged.push({ key: canonicalName, value: canonicalName, text: canonicalName });
            });

            return merged;
        })();

        const selectedFileNormalized = toCanonicalTemplateName(this.state.selectedFile);
        const isSelectedFromUpdatedNames = apiTemplateNames.some(name => toCanonicalTemplateName(name) === selectedFileNormalized);
        const isSelectedStaticTemplate = staticTemplateNameSet.has(selectedFileNormalized);

        const normalizedSelectedFile = toCanonicalTemplateName(this.state.selectedFile);
        const dynamicSelectedStatus = this.state.dynamicFileStatusByName[normalizedSelectedFile] || 'Pending';
        const dynamicSelectedUrl = this.state.dynamicFileUrlByName[normalizedSelectedFile] || '';
        const dynamicSelectedUpdatedAt = this.state.dynamicFileUpdatedAtByName[normalizedSelectedFile] || null;
        const dynamicSelectedError = this.state.dynamicFileErrorByName[normalizedSelectedFile] || null;
        const filterLabelStyle = { display: 'block', marginBottom: 6, fontWeight: 600, color: 'rgba(0,0,0,.6)' };

        var photoAuditTeam = [
            { key: 'Hotspot Smartspot Execution', value: 'Hotspot Smartspot Execution', text: 'Hotspot Smartspot Execution' },
            { key: 'Photo Audit', value: 'Photo Audit', text: 'Photo Audit' },
            { key: 'Physical Audit', value: 'Physical Audit', text: 'Physical Audit' },
            { key: 'StoreMaster/SellerMaster', value: 'StoreMaster/SellerMaster', text: 'StoreMaster / SellerMaster' },
        ]

        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 12 }}>
                    <div>
                        <h1 style={{ color: "#2185d0", marginBottom: 4 }}>
                            Raw File Processing
                        </h1>
                        <div style={{ color: 'rgba(0,0,0,.55)' }}>
                            Select a month and a file to run it or download the output.
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        {this.state.lastFetchedAt && (
                            <span style={{ color: 'rgba(0,0,0,.55)', fontSize: '0.92em' }}>
                                Status as of {formatDateTime(this.state.lastFetchedAt)}
                            </span>
                        )}
                        <Button
                            basic
                            icon
                            labelPosition='left'
                            loading={this.state.refreshing}
                            disabled={!this.state.templateId || this.state.refreshing}
                            onClick={() => this.fetchFileStatuses()}
                        >
                            <Icon name='refresh' />
                            Refresh
                        </Button>
                    </div>
                </div>

                {/* StoreMaster/SellerMaster modal — rendered outside the dropdown flow */}
                {this.state.smsmModalOpen && (
                    <SMSMAutomation
                        templateId={this.state.templateId}
                        templateName={this.state.selectedTemplateName}
                        defaultOpen={true}
                        onClose={() => this.setState({ smsmModalOpen: false, selectedFile: '' })}
                    />
                )}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, marginTop: 20 }}>
                    <div>
                        <label style={filterLabelStyle}>Month</label>
                        <Dropdown
                            placeholder='Select Month'
                            search
                            selection
                            options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>
                    <div style={{ minWidth: 300 }}>
                        <label style={filterLabelStyle}>File</label>
                        {(this.props.auth.userName === "Admin" || this.props.auth.userName === "MatrixLogin") &&
                            // ✅ fileTypes now includes updatedTemplateNames dynamically
                            <Dropdown
                                placeholder='Select File'
                                search
                                selection
                                options={fileTypes}
                                onChange={this.dropDownFileOnChange}
                                value={this.state.selectedFile}
                            />
                        }
                        {this.props.auth.userName === "PhotoAudit" &&
                            <Dropdown
                                placeholder='Select File'
                                search
                                selection
                                options={photoAuditTeam}
                                onChange={this.dropDownFileOnChange}
                                value={this.state.selectedFile}
                            />
                        }
                    </div>
                </div>

                {!this.state.selectedFile && (
                    <Message info icon style={{ marginTop: 20, maxWidth: 640 }}>
                        <Icon name='hand point up outline' />
                        <Message.Content>
                            <Message.Header>Select a file</Message.Header>
                            Choose a file above to see its status and when it was last updated (DD/MM/YYYY).
                        </Message.Content>
                    </Message>
                )}

                {this.state.selectedFile == 'Channel 1 Target' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Channel 1 Target', 'Channel 1 Target Raw File Process', 'channale1Status', 'channel1FileUrl', 'Channel 1 Target', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Hotspot Smartspot Execution' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Hotspot Smartspot Execution', 'Hotspot Smartspot Execution Raw File Process', 'executionStatus', 'executionFileUrl', 'Hotspot Smartspot Execution', 'hotspotSmartspotExecution')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Cluster Master Console File' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Cluster Master Console File', 'Cluster Master Console File Process', 'clusterMasterConsoleStatus', 'clusterConsoleUrl', 'Cluster Master Console File', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'DGP Target' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('DGP Target', 'DGP Target Raw File Process', 'dgpTaregtStatus', 'dgpTargetFileUrl', 'DGP Target', 'dgpTarget')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'ISMP Cluster Incentive Console file' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('ISMP Cluster Incentive Console file', 'ISMP Cluster Incentive Console file Process', 'ismpConsoleStatus', 'ismpConsoleFileUrl', 'ISMP Cluster Incentive Console file', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'SBD Cluster Target' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('SBD Cluster Target', 'SBD Cluster Target Raw File Process', 'sbdClusterTargetStatus', 'sbdClusterTargetUrl', 'SBD Cluster Target', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Visibility Cluster Incentive Console file' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Visibility Cluster Incentive Console file', 'Visibility Cluster Incentive Console file Process', 'visibilityConsoleStatus', 'visibilityConsolefileUrl', 'Visibility Cluster Incentive Console file', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'WS Target Console File' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('WS Target Console File', 'WS Target Console File Process', 'wsTargetConsoleStatus', 'wsTargetConsolUrl', 'WS Target Console File', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Red Route Reduction Incentive' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Red Route Reduction Incentive', 'Red Route Reduction Incentive Process', 'redRouteTargetStatus', 'redRouteTargetUrl', 'Red Route Reduction Incentive', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'WS POTPR Target Console File' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('WS POTPR Target Console File', 'WS POTPR Target Console File Process', 'wsPOTPRTargetConsoleStatus', 'wsPOTPRTargetConsolUrl', 'WS POTPR Target Console File', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'SubDPI Console File' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('SubDPI Console File', 'SubDPI Console File Process', 'subdPiConsoleStatus', 'subdPiConsolUrl', 'SubDPI Console File', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Chain Master' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Chain Master', 'Chain Master Raw File Process', 'chainMasterStatus', 'chainMasterUrl', 'Chain Master', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Visibility FB Target' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Visibility FB Target', 'Visibility FB Target Raw File Process', 'visibilityFBTargetStatus', 'visibilityFBTargetUrl', 'Visibility FB Target', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Visibility Target' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Visibility Target', 'Visibility Target Raw File Process', 'visibilityTargetStatus', 'visibilityTargetUrl', 'Visibility Target', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'MR Cluster Master' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('MR Cluster Master', 'MR Cluster Master Raw File Process', 'mrClusterMasterStatus', 'mrClusterMasterUrl', 'MR Cluster Master', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Adaptive Trade Terms' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Adaptive Trade Terms', 'Adaptive Trade Terms Raw File Process', 'adaptiveTradeTermsStatus', 'adaptiveTradeTermsUrl', 'Adaptive Trade Terms', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'PC DC Template' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('PC DC Template', 'PC DC Template Raw File Process', 'pcdcTemplateStatus', 'pcdcTemplateUrl', 'PC DC Template', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Gold Rush' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Gold Rush', 'Gold Rush Raw File Process', 'goldRushTemplateStatus', 'goldRushTemplateUrl', 'Gold Rush', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'DGP Archivement' && (
                    <Grid columns={3} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderCard({
                                title: 'DGP Archivement - LEAP',
                                description: 'DGP Archivement Raw File Process',
                                statusKey: 'dgpArchivementLeapStatus',
                                urlKey: 'dgpArchivementLeapFileUrl',
                                fileName: 'DGP Archivement',
                                fileType: 'LEAP'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'DGP Archivement - SubD',
                                description: 'DGP Archivement Raw File Process',
                                statusKey: 'dgpArchivementSubDStatus',
                                urlKey: 'dgpArchivementSubDFileUrl',
                                fileName: 'DGP Archivement',
                                fileType: 'SubD'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'DGP Archivement',
                                description: 'DGP Archivement Concat both Leap & SubD',
                                statusKey: 'dgpArchivementConcatStatus',
                                urlKey: 'dgpArchivementConcatFileUrl',
                                fileName: 'DGP Archivement',
                                fileType: 'Concat'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'DGP File Web Automation',
                                description: 'Downlaod Leap & SubD Files from the portal',
                                statusKey: null,
                                fileName: 'DGP Archivement',
                                fileType: 'automation',
                                customActions: (
                                    <>
                                        <Button basic color='red' onClick={() => this.runLeap()}>
                                            <Icon name="play" />LEAP
                                        </Button>
                                        <Button basic color='red' onClick={() => this.runSubd()}>
                                            <Icon name="play" />SUBD
                                        </Button>
                                    </>
                                )
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'DGP Web Automation Credentials',
                                description: 'Credentials data for leap portal',
                                statusKey: null,
                                fileName: 'Credential File',
                                fileType: 'credentials',
                                customActions: (
                                    <>
                                        <Button basic color='green' onClick={() => this.uploadFile('Credential File', 'Credential File')}>
                                            <Icon name="upload" />Upload
                                        </Button>
                                        <Button basic color='green' onClick={() => this.editCredentials()}>
                                            <Icon name="edit" />Edit
                                        </Button>
                                    </>
                                )
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'DGP Auto Run',
                                description: 'Tool Automatically Run 7th of every month',
                                statusKey: null,
                                fileName: 'DGP Archivement',
                                fileType: 'autorun',
                                additionalContent: (
                                    <Checkbox
                                        toggle
                                        label='Auto Run'
                                        checked={this.state.autoRunStatus == 'enable'}
                                        onChange={this.check}
                                    />
                                )
                            })}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'PSR' && (
                    <Grid columns={3} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderCard({
                                title: 'PSR - LEAP',
                                description: 'PSR LEAP Raw File Process',
                                statusKey: 'psrLeapStatus',
                                urlKey: 'psrLeapFileUrl',
                                fileName: 'PSR Target',
                                fileType: 'LEAP'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'PSR - SubD',
                                description: 'PSR SubD Raw File Process',
                                statusKey: 'psrSubdStatus',
                                urlKey: 'psrSubDFileUrl',
                                fileName: 'PSR Target',
                                fileType: 'SubD'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'PSR - Concat',
                                description: 'PSR Concat for specific channels(Hotspot,Smartspot,WS)',
                                statusKey: 'psrConcatStatus',
                                urlKey: 'psrConcatFileUrl',
                                fileName: 'PSR Target',
                                fileType: 'Concat'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'Sector Mapping',
                                description: 'Sector Mapping File',
                                statusKey: 'sectorMappingStatus',
                                urlKey: 'sectorMappingUrl',
                                fileName: 'Sector Mapping',
                                fileType: 'sectorMapping',
                                actionType: 'upload'
                            })}
                        </GridColumn>
                        {/* <GridColumn>
                            {this.renderCard({
                                title: 'PSR All LEAP',
                                description: 'PSR LEAP Raw File Process',
                                statusKey: 'psrAllLeapStatus',
                                urlKey: 'psrAllLeapFileUrl',
                                fileName: 'PSR Target All',
                                fileType: 'LEAP ALL'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'PSR All SubD',
                                description: 'PSR SubD Raw File Process',
                                statusKey: 'psrAllSubdStatus',
                                urlKey: 'psrAllSubDFileUrl',
                                fileName: 'PSR Target All',
                                fileType: 'SubD ALL'
                            })}
                        </GridColumn> */}
                        <GridColumn>
                            {this.renderCard({
                                title: 'PSR - Concat All Channels',
                                description: 'PSR Concat for all Channels',
                                statusKey: 'psrAllConcatStatus',
                                urlKey: 'psrAllConcatFileUrl',
                                fileName: 'PSR Target All',
                                fileType: 'Concat'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({
                                title: 'PSR - GoldRush',
                                description: 'PSR GoldRush Raw File Process',
                                statusKey: 'psrGoldRushStatus',
                                urlKey: 'psrGoldRushFileUrl',
                                fileName: 'PSR - GoldRush',
                                fileType: 'GoldRush'
                            })}
                        </GridColumn>
                        <GridColumn>
                            {this.state.missingSectorsList.length > 0 &&
                                <Message negative>
                                    <Message.Header>{"Missing Category & Brands"}</Message.Header>
                                    {this.state.missingSectorsList.map((d, idx) => (
                                        <p key={idx}><li>{d}</li></p>
                                    ))}
                                </Message>
                            }
                            {this.state.missingSectorsList.length == 0 &&
                                <Message positive>
                                    <Message.Header>{"Missing Category & Brands "}</Message.Header>
                                    <p>There is no missing Data. All the Categories & Brands available in Mapping file.</p>
                                </Message>
                            }
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Photo Audit' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderUploadCard('Photo Audit', 'Photo Audit Raw File', 'photoAuditStatus', 'photoAuditFileUrl', 'Photo Audit', 'photoAudit')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Hero Brand' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            <HeroBrandAutomation templateId={this.state.templateId} />
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Physical Audit' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderUploadCard('Physical Audit', 'Physical Audit Raw File', 'physicalAuditFileStatus', 'physicalAuditFileUrl', 'Physical Audit', 'physicalAudit')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Channel & Photo' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Channel1 Target With Photo Audit', 'Channel 1 Target & Photo Audit Missing Data Merge Process', 'mergeStatus', 'mergeFileUrl', 'Channel & Photo', 'channel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'SGF Fixed rack rate' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderUploadCard('SGF Fixed Rack Rate', 'SGF Fixed Rack Rate Master File', 'sgfFixedRackRateFileStatus', 'sgfFixedRackRateFileUrl', 'SGF Fixed rack rate', 'sgfFixedRack')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'DGP Top Channel Corporate Program Targets' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderUploadCard('DGP Top Channel Corporate Program Targets', 'DGP Top Channel Corporate Program Targets By Channel', 'dgpTopChannelFileStatus', 'dgpTopChannelFileUrl', 'DGP Top Channel Corporate Program Targets', 'dgpTopChannel')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Seller vs Physical - SGF final report' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderUploadCard('SGF final report', 'Seller vs Physical - SGF Final Report', 'sgfFinalReportFileStatus', 'sgfFinalReportFileUrl', 'Seller vs Physical - SGF final report', 'sgfFinalReport')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Percentage Mapping file' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderUploadCard('Percentage Mapping File', 'Percentage Mapping Master File', 'percentageMappingFileStatus', 'percentageMappingFileUrl', 'Percentage Mapping file', 'percentageMapping')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'DSE Mapping' && (
                    <Grid columns={4} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderCard({ title: 'DGP Arch - LEAP', description: 'DGP Arch Leap Consolidated File', statusKey: 'soormaLeapStatus', urlKey: 'soormaLeapFileUrl', fileName: 'SoormaWorking', fileType: 'LEAP' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'DGP Arch - SubD', description: 'DGP Arch SubD Consolidated File', statusKey: 'soormaSubDStatus', urlKey: 'soormaSubdFileUrl', fileName: 'SoormaWorking', fileType: 'SubD' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'DGP Arch - LEAP DSE Mapping', description: 'DGP Arch LEAP File DSE Mapping Process', statusKey: 'soormaLeapDseMappingStatus', urlKey: 'soormaLeapDseMappingUrl', fileName: 'Soorma DSE Mapping', fileType: 'LEAP' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'DGP Arch - SubD DSE Mapping', description: 'DGP Arch SubD File DSE Mapping Process', statusKey: 'soormaSubdDseMappingStatus', urlKey: 'soormaSubdDseMappingUrl', fileName: 'Soorma DSE Mapping', fileType: 'SubD' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'Focus Brand - LEAP', description: 'Focus Brand Leap Consolidated File', statusKey: 'fbLeapStatus', urlKey: 'fbLeapFileUrl', fileName: 'Focus Brand Leap', fileType: 'fbLeap' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'Focus Brand - SubD', description: 'Focus Brand SubD Consolidated File', statusKey: 'fbSubdStatus', urlKey: 'fbSubDFileUrl', fileName: 'Focus Brand SubD', fileType: 'focusBrandSubD' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'FB - LEAP DSE Mapping', description: 'FB LEAP File DSE Mapping Process', statusKey: 'fbLeapDseMappingStatus', urlKey: 'fbLeapDseMappingFileUrl', fileName: 'Focus Brand DSE Mapping', fileType: 'LEAP' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'FB - SubD DSE Mapping', description: 'FB SubD File DSE Mapping Process', statusKey: 'fbSubdDseMappingStatus', urlKey: 'fbSubdDseMappingUrl', fileName: 'Focus Brand DSE Mapping', fileType: 'SubD' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'Smartline - LEAP', description: 'Smartline Leap Consolidated File', statusKey: 'smartlineLeapStatus', urlKey: 'smartlineLeapFileUrl', fileName: 'Smartline Leap', fileType: 'smartlineLeap' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'Smartline - SubD', description: 'Smartline SubD Consolidated File', statusKey: 'smartlineSubDStatus', urlKey: 'smartlineSubDFileUrl', fileName: 'Smartline SubD', fileType: 'smartlineSubD' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'Smartline - LEAP DSE Mapping', description: 'Smartline LEAP File DSE Mapping Process', statusKey: 'smartlineLeapDseMappingStatus', urlKey: 'smartlineLeapDseMappingUrl', fileName: 'Smartline DSE Mapping', fileType: 'LEAP' })}
                        </GridColumn>
                        <GridColumn>
                            {this.renderCard({ title: 'Smartline - SubD DSE Mapping', description: 'Smartline SubD File DSE Mapping Process', statusKey: 'smartlineSubdDseMappingStatus', urlKey: 'smartlineSubdDseMappingUrl', fileName: 'Smartline DSE Mapping', fileType: 'SubD' })}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'PG Target SubDPI' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderStatusCard('PG Target SubDPI', 'PG Target SubDPI Raw File', 'pgtargetSubdPiStatus', 'pgtargetSubdPiUrl', 'PG Target SubDPI', 'pgtargetSubdPI', 'upload')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Visibility Champions League targets' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderStatusCard('Visibility Champions League targets', 'Visibility Champions League targets Raw File Process', 'visibilityChampionTargetStatus', 'visibilityChampionTargetUrl', 'Visibility Champions League targets', 'visibilityChampion', 'play')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'BranchSubDStore code changes' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderStatusCard('BranchSubDStore code changes', 'BranchSubDStore code changes Raw File Process', 'branchSubdStoreStatus', 'branchSubdUrl', 'BranchSubDStore code changes', 'branchSubDStore', 'play')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'CENTURY CLUB VCL  TARGET' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderStatusCard('CENTURY CLUB VCL  TARGET', 'CENTURY CLUB VCL  TARGET Raw File Process', 'centuryClubStatus', 'centuryClubUrl', 'CENTURY CLUB VCL  TARGET', 'centuryClub', 'play')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'QDGP Target' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderStatusCard('QDGP Target', 'QDGP Target Raw File', 'qdgpTargetStatus', 'qdgpTargetUrl', 'QDGP Target', 'qdgpTarget', 'upload')}
                        </GridColumn>
                    </Grid>
                )}
                {this.state.selectedFile == 'Visibility Execution Tracker' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderStatusCard('Visibility Execution Tracker', 'Visibility Execution Tracker Raw File', 'visibilityExecutionTrackerStatus', 'visibilityExecutionTrackerUrl', 'Visibility Execution Tracker', 'visibilityExecutionTracker', 'upload')}
                        </GridColumn>
                    </Grid>
                )}

                {this.state.selectedFile == 'Route Master' && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderProcessCard('Route Master', 'Route Master Raw File Process', 'routeMasterStatus', 'routeMasterUrl', 'Route Master', 'channel')}
                        </GridColumn>
                    </Grid>
                )}

                {/* ✅ Dynamic template names from getUpdatedTemplateName API - shows Start button with status tracking */}
                {isSelectedFromUpdatedNames && !isSelectedStaticTemplate && (
                    <Grid columns={1} style={{ marginTop: 20 }}>
                        <GridColumn>
                            {this.renderCard({
                                title: this.state.selectedFile,
                                description: `${this.state.selectedFile} Raw File Process`,
                                statusValue: dynamicSelectedStatus,
                                urlValue: dynamicSelectedUrl,
                                updatedAtValue: dynamicSelectedUpdatedAt,
                                errorValue: dynamicSelectedError,
                                fileName: this.state.selectedFile,
                                fileType: 'channel'
                            })}
                        </GridColumn>
                    </Grid>
                )}

                <Modal open={this.state.modalOpen} onClose={this.closeuploadoption} size="mini">
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input type="file" accept=".xlsx" onChange={this.fileupload} multiple />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={() => this.uploadRawFile(this.state.fileType, this.state.fileName)}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>
                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>

                {this.state.credentialsData.length > 0 && this.state.credentialModalOpen == true &&
                    <div style={{ display: "flex", overflowX: "scroll", marginTop: 20 }}>
                        <ReactTable
                            noDataText="We couldn't find anything"
                            filterable={true}
                            defaultPageSize={20}
                            sortable={true}
                            style={{ width: "85vw", marginLeft: 30 }}
                            columns={columns}
                            data={this.state.credentialsData}
                        />
                    </div>
                }

                <Modal open={this.state.Editmode} onClose={this.closeModal} size="small">
                    <Modal.Content>
                        <Form>
                            <Grid columns={2}>
                                <Grid.Row>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input type="text" label="URL" value={this.state.url} onChange={(e) => this.urlChange(e)} placeholder="URL" />
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input type="text" label="Cloud" value={this.state.cloud} onChange={(e) => this.cloudChange(e)} placeholder="Cloud" />
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input type="any" label="User Name" value={this.state.userName} onChange={(e) => this.userNameChange(e)} placeholder="User Name" />
                                    </Grid.Column>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <Form.Input type="any" label="Password" value={this.state.password} onChange={(e) => this.passwordChange(e)} placeholder="Password" />
                                    </Grid.Column>
                                    <GridColumn></GridColumn>
                                    <GridColumn></GridColumn>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions style={{ marginTop: 20 }}>
                        <Button color="red" onClick={this.closeModal}>
                            <Icon name="remove" /> Cancel
                        </Button>
                        {this.state.Editmode &&
                            <Button color="green" onClick={this.saveCredentialData} disabled={this.state.editCred == true ? false : true}>
                                Save
                            </Button>
                        }
                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchTemplates,
            fetchUseraction,
            rawFileProcess,
            psrTargetRawFileProcess,
            fetchRawFilesData,
            runLeapAutomation,
            runSubDAutomation,
            editCredentialsData,
            updateCredentialsData,
            updateAutoRunStatus,
            getUpdatedTemplateName
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RawFileProcess));
